import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import theme from '@theme';
import { StyledB2BNav } from './styled';

const B2BHeaderNav = ({ children }) => (
  <ThemeProvider theme={theme}>
    <StyledB2BNav>{children}</StyledB2BNav>
  </ThemeProvider>
);

B2BHeaderNav.propTypes = {
  children: PropTypes.node.isRequired,
};

export default B2BHeaderNav;
